import React, { useState } from 'react';
import { IconPlus, IconTrash } from './Icons';

interface VariablesEditorProps {
  variables: Record<string, string>;
  onChange: (variables: Record<string, string>) => void;
}

export const VariablesEditor: React.FC<VariablesEditorProps> = ({
  variables,
  onChange
}) => {
  const [newKey, setNewKey] = useState('');
  const [newVal, setNewVal] = useState('');

  const handleAdd = () => {
    const cleanKey = newKey.trim().replace(/[^a-zA-Z0-9_-]/g, '');
    if (!cleanKey) return;
    onChange({
      ...variables,
      [cleanKey]: newVal.trim()
    });
    setNewKey('');
    setNewVal('');
  };

  const handleRemove = (keyToRemove: string) => {
    const next = { ...variables };
    delete next[keyToRemove];
    onChange(next);
  };

  const handleUpdate = (key: string, val: string) => {
    onChange({
      ...variables,
      [key]: val
    });
  };

  // Вычисляем длину самого длинного бейджа переменной {{key}} для гарантии единой ширины
  const longestKeyLen = Object.keys(variables).reduce((max, k) => Math.max(max, `{{${k}}}`.length), 0);
  const badgeWidthStyle = longestKeyLen > 0 ? `calc(${longestKeyLen}ch + 24px)` : '160px';

  return (
    <div className="variables-editor-container">
      <div className="variables-editor-header">
        <label className="variables-title">ПЕРЕМЕННЫЕ БОТА (НАСТРОЙКИ ДЛЯ ШАБЛОНА):</label>
      </div>

      <div
        className="variables-list"
        style={{ '--badge-width': badgeWidthStyle } as React.CSSProperties}
      >
        {Object.entries(variables).map(([key, val]) => (
          <div key={key} className="variable-row">
            <span className="variable-key-badge font-mono">{`{{${key}}}`}</span>
            <input
              type="text"
              className="variable-val-input"
              value={val}
              placeholder="Значение переменной или {{curl(url)}}..."
              onChange={(e) => handleUpdate(key, e.target.value)}
            />
            <button
              type="button"
              className="btn btn-outline btn-icon-only"
              onClick={() => handleRemove(key)}
              title={`Удалить переменную {{${key}}}`}
            >
              <IconTrash size={13} />
            </button>
          </div>
        ))}
      </div>

      {/* Форма добавления новой переменной */}
      <div
        className="variable-add-row"
        style={{ '--badge-width': badgeWidthStyle } as React.CSSProperties}
      >
        <input
          type="text"
          className="variable-key-new font-mono"
          placeholder="имя_переменной"
          value={newKey}
          onChange={(e) => setNewKey(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAdd(); } }}
        />
        <input
          type="text"
          className="variable-val-new"
          placeholder="значение (например: https://api.pchelp.ru/price или {{curl(current_price_url)}})"
          value={newVal}
          onChange={(e) => setNewVal(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAdd(); } }}
        />
        <button
          type="button"
          className="btn btn-secondary btn-icon-only"
          onClick={handleAdd}
          disabled={!newKey.trim()}
          title="Добавить переменную"
        >
          <IconPlus size={14} />
        </button>
      </div>
    </div>
  );
};
